import {defineToolRegistryManifest} from '../../types/base-tool-types';
import {z} from 'zod';
import dedent from 'dedent';

const toolName = 'set-component-name' as const;

const argumentZod = z.object({
  componentId: z
    .string()
    .describe('The ID of the component to set the name for.'),
  name: z.string().describe('The new name to give the component.'),
});

export const setComponentNameTool = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Set component name',
  llmTool: {
    name: toolName,
    description: dedent`Set the name of a component object by its ID. This updates the component's display name which is used throughout the Designer interface.

    This should only be used for non-code components, because the names for code components are declared in the code itself.
    `,
    inputSchema: argumentZod,
  },
  type: 'designer',
  permission: [{resource: 'SiteSymbol', action: 'manage'}],
  confirmBeforeExecuting: false, // Renaming is not destructive
  timeout: 30000, // 30 seconds for setting component name
});

export type SetComponentNameArgumentType = z.infer<typeof argumentZod>;
